import { render, staticRenderFns } from "./drawing-manager.vue?vue&type=template&id=615a2184"
import script from "./drawing-manager.vue?vue&type=script&lang=js"
export * from "./drawing-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports